import { autorun } from 'mobx';

class LoginHomeController {

    constructor(
        $timeout,
        GoogleSSOService
    ){
        'ngInject';
        this.$timeout = $timeout;
        this.GoogleSSOService = GoogleSSOService;
    }

    $onInit() {
        this.dispose = autorun(() => {
            this.loginErrorMessage = this.GoogleSSOService.loginErrorMessage;
        });
    }

    $onDestroy() {
        this.dispose();
    }

}

export default LoginHomeController;


// WEBPACK FOOTER //
// ./app/components/home/login-home/login-home-controller.js